var base = require('settings/api/tokens');

Vue.component('spark-tokens', {
    mixins: [base]
});



// WEBPACK FOOTER //
// ./resources/js/spark-components/settings/api/tokens.js